/* src/app/artic-run-diary/modals/artic-run-diary-set-allocation-modal/artic-run-diary-set-allocation-modal.component.scss */
/*# sourceMappingURL=artic-run-diary-set-allocation-modal.component.css.map */
